import axios from 'axios';
import config from '../../config/config';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const apiURL = config.apiUrl;
const path = config.path;

// Async thunk for fetching packages data
export const fetchPackages = createAsyncThunk('packages/fetchPackages', async () => {
    const response = await axios.get(`${apiURL}/fetch/CreditPackage`);
    const sortedData = response.data.data.sort((a, b) => a.ai_credits - b.ai_credits);
    return sortedData;
  });

const packageSlice = createSlice({
  name: 'packages',
  initialState: {
    items: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackages.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default packageSlice.reducer;

export const selectPackages = (state) => state.packages.items;
